// eslint-disable-next-line jira/restricted/react
import React, { PureComponent } from 'react';
import FilterSearch from '@atlassian/jira-common-components-filter-search';
import { ff } from '@atlassian/jira-feature-flagging';
import type { AnalyticsData } from '../../state/analytics/types';

type Props = {
	value: string;
	onChange: (value: string) => void;
	analyticsData: AnalyticsData;
	ariaLabel?: string;
};

// eslint-disable-next-line jira/react/no-class-components
export default class FilterView extends PureComponent<Props> {
	static defaultProps: Partial<Props> = {
		value: '',
	};

	onChange = (value: string) => {
		this.props.onChange(value);
	};

	render() {
		const { value = '' } = this.props;

		return ff('sea-2744-jsw-tabs-nav') ? (
			<FilterSearch value={value} onChange={this.onChange} ariaLabelText={this.props.ariaLabel} />
		) : (
			<FilterSearch value={value} onChange={this.onChange} />
		);
	}
}
